import { PROSPECT_ENDPOINTS } from '../../../utils/api/endpoints/prospectEndpoints';
import { QueryPendingProspectResponse, UsePendingProspectParams } from './usePendingProspect.types';

const PREFIX = '[pendingProspectQuery]';

export const queryPendingProspect = async (params: UsePendingProspectParams) => {
  console.log(PREFIX, `Fetching pending prospect...`);
  const response = await PROSPECT_ENDPOINTS.pending(params);

  const { ok, data: json } = response;

  if (!ok) {
    const error = response.data;
    console.log(PREFIX, 'An error occurred.', error);
    throw error;
  }

  console.log(PREFIX, `Received pending prospect.`);
  return json as QueryPendingProspectResponse;
};
